import React from 'react'
import { Link } from 'react-router-dom'
import { BtnV2, Icon, l } from '@manychat/manyui'

import { useAppDispatch } from 'reduxTyped'
import { SidebarHeader } from 'apps/aiAutomation/components/SidebarHeader'
import { AiAutomationLayoutActions } from 'apps/aiAutomation/store/layout'
import { typedRouting } from 'utils/router'

import cm from './styles.module.css'

export const InvalidKnowledge = () => {
  const dispatch = useAppDispatch()

  return (
    <section className="h-full">
      <SidebarHeader title={l.translate('AI Replies')} />
      <div className={cm.wrapper}>
        <div className={cm.content}>
          <Icon.Attention className="text-danger" size={32} />

          <h3 className="m-t-sm text-subheading">{l.translate('AI Replies can’t go live')}</h3>

          <p className="m-t-xs">
            {l.translate(
              'Something went wrong with the Knowledge you shared, review it to put AI Replies live.',
            )}
          </p>

          <BtnV2
            as={Link}
            to={typedRouting.linkBuilder.aiTraining()}
            onClick={() => dispatch(AiAutomationLayoutActions.sidebarClosed())}
            variant="primary"
            fullWidth
            className="m-t-md"
          >
            {l.translate('Review Knowledge')}
          </BtnV2>
        </div>
      </div>
    </section>
  )
}
